(() => {
  if (customElements.get('cart-item-variant-upsell')) return;

  class CartItemVariantUpsell extends HTMLElement {
    constructor() {
      super();
      this.onAddClick = this.onAddClick.bind(this);
    }

    connectedCallback() {
      this.addButton = this.querySelector('.js-cart-item-variant-upsell-button');
      this.setEventListeners();
    }

    disconnectedCallback() {
      this.removeEventListeners();
    }

    setEventListeners() {
      this.addButton?.addEventListener('click', this.onAddClick);
    }

    removeEventListeners() {
      this.addButton?.removeEventListener('click', this.onAddClick);
    }

    async onAddClick() {
      const { line, newQuantity } = this.dataset;
      if (!line || !newQuantity) return;

      this.setLoading(true);

      const cartDrawer = document.querySelector('cart-drawer');
      if (cartDrawer && typeof cartDrawer.setUpdating === 'function') {
        cartDrawer.setUpdating(true);
      }

      try {
        const body = JSON.stringify({
          line: parseInt(line, 10),
          quantity: parseInt(newQuantity, 10),
          sections: ['cart-drawer', 'cart-icon-bubble'],
        });

        const res = await fetch(`${window.Shopify.routes.root}cart/change.js`, {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            'Accept': 'application/json',
          },
          body,
        });

        if (!res.ok) {
          const err = await res.json();
          throw new Error(err.description);
        }

        const data = await res.json();
        this.renderSections(data.sections);
      } catch (error) {
        console.error('[CartItemVariantUpsell] Error:', error);
      } finally {
        if (cartDrawer && typeof cartDrawer.setUpdating === 'function') {
          cartDrawer.setUpdating(false);
        }
        this.setLoading(false);
      }
    }

    renderSections(sections) {
      if (!sections) return;

      const cartDrawerHtml = sections['cart-drawer'];
      if (cartDrawerHtml) {
        const parser = new DOMParser();
        const doc = parser.parseFromString(cartDrawerHtml, 'text/html');

        const cartDrawerEl = document.getElementById('CartDrawer');
        if (cartDrawerEl) {
          const parts = [
            '.js-drawer-header',
            '.js-drawer-inner',
            '.js-drawer-footer',
          ];
          parts.forEach((selector) => {
            const current = cartDrawerEl.querySelector(selector);
            const next = doc.querySelector(selector);
            if (current && next) current.innerHTML = next.innerHTML;
          });
        }
      }

      const bubbleHtml = sections['cart-icon-bubble'];
      if (bubbleHtml) {
        const bubbleEl = document.getElementById('cart-icon-bubble');
        if (bubbleEl) {
          const doc = new DOMParser().parseFromString(bubbleHtml, 'text/html');
          const newBubble = doc.querySelector('.shopify-section');
          if (newBubble) bubbleEl.innerHTML = newBubble.innerHTML;
        }
      }
    }

    setLoading(isLoading) {
      if (isLoading) {
        this.addButton?.setAttribute('disabled', '');
        this.addButton?.classList.add('is-loading');
      } else {
        this.addButton?.removeAttribute('disabled');
        this.addButton?.classList.remove('is-loading');
      }
    }
  }

  customElements.define('cart-item-variant-upsell', CartItemVariantUpsell);
})();
